const ThankYou = () => import(/* webpackChunkName: "thank-you" */ './ThankYou');

export default {
  path: '/purchase/thank-you',
  component: ThankYou,
  name: 'thankYou',
};